import { render, staticRenderFns } from "./VideoSection.vue?vue&type=template&id=7204d7c6&scoped=true&"
var script = {}
import style0 from "./VideoSection.vue?vue&type=style&index=0&id=7204d7c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7204d7c6",
  null
  
)

export default component.exports